const LGChairman = () => {
    return (<article>
        <p>In Nigeria, Local Governments are the third tier of government,
            bringing governance closer to the grassroots. The Local Government
            Chairman and Vice Chairman are key figures in the executive arm of this
            tier.</p>
        <p>Here’s a breakdown of their roles:</p>
        <h3><strong>Local Government Chairman:</strong></h3>
        <p>The Local Government Chairman is the <strong>Chief Executive Officer
            (CEO)</strong> of the Local Government Area (LGA). Their
            responsibilities are extensive and include:</p>
        <ul>
            <li><strong>Administration and Leadership:</strong>
                <ol>
                    <li>Directing the affairs of the local government.</li>
                    <li>Supervising the activities of all departments within the LGA.</li>
                    <li>Presiding over meetings of the Local Government Council (the
                        executive committee).</li>
                    <li>Allocating responsibilities to the Vice Chairman, Supervisors
                        (commissioners for specific departments), and the Secretary to the Local
                        Government.</li>
                    <li>Maintaining liaison with the legislative arm (the Councillors).</li>
                    <li>Countersigning Annual Performance Evaluation Reports of departmental
                        heads.</li>
                    <li>Addressing the Local Government Council at least once a year to
                        account for achievements and challenges.</li>
                </ol>
            </li>
            <li><strong>Financial Management:</strong>
                <ol>
                    <li>Observing and complying with financial regulations and
                        guidelines.</li>
                    <li>Ensuring accountability for public funds.</li>
                    <li>Rendering monthly statements of income and expenditures, and annual
                        reports to the Local Government Council for consideration and
                        debate.</li>
                    <li>Rendering quarterly returns of actual income and expenditure to the
                        state government.</li>
                    <li>Presenting the annual budget to the Local Government Council for
                        consideration and approval.</li>
                </ol>
            </li>
            <li><strong>Policy and Development:</strong>
                <ol>
                    <li>Participating in economic planning and development within the
                        LGA.</li>
                    <li>Making recommendations to state commissions on economic development
                        as it affects the local government.</li>
                    <li>Consulting with the Vice Chairman, Supervisors, and Secretary in
                        exercising administrative and financial functions.</li>
                    <li>Formulating and implementing local policies.</li>
                </ol>
            </li>
            <li><strong>Provision of Services:</strong>
                <p>Local governments are
                    responsible for a wide range of services, which the Chairman oversees,
                    including (but not limited to):
                </p>
                <ol>
                    <li>Collection of rates, radio and television licenses.</li>
                    <li>Establishment and maintenance of cemeteries, burial grounds, and
                        homes for the destitute.</li>
                    <li>Licensing of bicycles, non-mechanically propelled trucks, canoes,
                        wheelbarrows, and carts.</li>
                    <li>Establishment, maintenance, and regulation of slaughterhouses,
                        markets, motor parks, and public conveniences.</li>
                    <li>Construction and maintenance of roads, streets, street lighting,
                        drains, and other public facilities.</li>
                    <li>Naming of roads and streets, and numbering of houses.</li>
                    <li>Provision and maintenance of public conveniences, sewage, and refuse
                        disposal.</li>
                    <li>Registration of births, deaths, and marriages.</li>
                    <li>Assessment of privately owned houses for levying rates.</li>
                    <li>Control and regulation of outdoor advertising, movement and keeping
                        of pets, shops and kiosks, restaurants, bakeries, laundries, and sale of
                        liquor.</li>
                    <li>Participation in the provision and maintenance of primary, adult,
                        and vocational education.</li>
                    <li>Development of agriculture and natural resources (excluding mineral
                        exploitation).</li>
                    <li>Provision and maintenance of health services.</li>
                </ol></li>
        </ul>
        <h2><strong>Local Government Vice Chairman:</strong></h2>
        <p>The Vice Chairman is elected along with the Chairman and plays a
            crucial supportive role. Their main duties include:</p>
        <ul>
            <li><strong>Deputizing for the Chairman:</strong> The Vice Chairman acts
                for the Chairman in their absence.</li>
            <li><strong>Assigned Responsibilities:</strong> The Chairman delegates
                administrative functions and authority to the Vice Chairman. This often
                includes being assigned responsibility for the administration of a
                specific department within the Local Government.</li>
            <li><strong>Involvement in Decision-Making:</strong> The Vice Chairman
                is fully involved in the key decision-making processes of the local
                government, participating in regular meetings with the Chairman,
                Supervisors, and Secretary.</li>
            <li><strong>Liaison:</strong> They may liaise with the Secretary to the
                State Government and other state functionaries on local government
                matters, and with the Local Government Council through the Leader of the
                House.</li>
            <li><strong>Accountability:</strong> Like the Chairman, the Vice
                Chairman can be called upon to account for their tenure even after
                leaving office.</li>
            <li><strong>Other Duties:</strong> They perform any other duties,
                including policy issues, as assigned by the Chairman from time to
                time.</li>
        </ul>
        <p>In essence, the Local Government Chairman is the primary
            decision-maker and administrator, responsible for the overall governance
            and development of the LGA, while the Vice Chairman assists the
            Chairman, takes on delegated responsibilities, and steps in when the
            Chairman is unavailable.</p>
    </article>
    )
}

export default LGChairman;